import type { DemoKey } from '../types';

export const ja: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '数学 · 統計',
  'app.title': '統計',
  'panel.experiment': 'シーン',
  'panel.params': 'パラメータ',

  'exp.survey-explorer.title': 'アンケート探索',
  'exp.survey-explorer.desc': '列を選ぶ ─ デモが適切な要約を選びます。',
  'exp.distribution-sculptor.title': '分布スカルプター',
  'exp.distribution-sculptor.desc': '点をドラッグして統計量の動きを観察。',
  'exp.two-variable-lab.title': '二変数ラボ',
  'exp.two-variable-lab.desc': '散布図、当てはめ、因果の問い。',
  'exp.sampling-lab.title': '標本抽出ラボ',
  'exp.sampling-lab.desc': '抽出方法とサンプルサイズが標本平均に与える影響。',
  'exp.probability-diagrams.title': '確率図',
  'exp.probability-diagrams.desc': '複合事象のベン図と樹形図。',

  'type.qualitative-nominal.label': '質的 · 名義',
  'type.qualitative-nominal.def': '順序のないカテゴリ。',
  'type.qualitative-ordinal.label': '質的 · 順序',
  'type.qualitative-ordinal.def': '意味のある順序を持つカテゴリ。',
  'type.qualitative-multi.label': '質的 · 複数値',
  'type.qualitative-multi.def': '1観測に複数タグが付き得る。',
  'type.quantitative-discrete.label': '量的 · 離散',
  'type.quantitative-discrete.def': '一定間隔の数値。',
  'type.quantitative-continuous.label': '量的 · 連続',
  'type.quantitative-continuous.def': '連続尺度で測る数値。',

  'column.name.label': '生徒名',
  'column.height_cm.label': '身長',
  'column.shoe_size_eu.label': '靴サイズ (EU)',
  'column.study_hours.label': '学習時間 / 週',
  'column.test_score.label': 'テスト点',
  'column.sports_played.label': 'プレー競技',
  'column.eye_color.label': '目の色',
  'column.commute_min.label': '通学時間',
  'column.grade_year.label': '学年',
  'column.homework_effort.label': '宿題の努力',
  'column.ice-cream-sales.label': 'アイス売上',
  'column.drownings.label': '溺死数',
  'column.month.label': '月',
  'column.storks.label': 'コウノトリ',
  'column.births.label': '出生数',
  'column.country_area_km2.label': '国土面積',
  'column.sleep_hours.label': '睡眠時間',
  'column.reaction_ms.label': '反応時間',

  'dataset.master-survey.label': 'クラスアンケート',
  'dataset.master-survey.desc': '30名のシミュレート生徒。',
  'dataset.spurious-ice-cream-vs-drownings.label': 'アイス売上 vs 溺死',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'どちらも季節で上下する。溺死がアイス売上の原因ではない。',
  'dataset.spurious-storks-vs-births.label': 'コウノトリ vs 出生',
  'dataset.spurious-storks-vs-births.desc':
    '大きい国ほどコウノトリも出生も多い。鳥が原因ではない。',
  'dataset.real-sleep-vs-reaction-time.label': '睡眠 vs 反応時間',
  'dataset.real-sleep-vs-reaction-time.desc':
    '睡眠が増えるほど反応が速い。本物の負の相関 ── 妥当なメカニズムも存在。',

  'tag.football.label': 'サッカー',
  'tag.basketball.label': 'バスケ',
  'tag.volleyball.label': 'バレーボール',
  'tag.swimming.label': '水泳',
  'tag.none.label': 'なし',

  'population.gaussian.label': '釣鐘型',
  'population.right-skewed.label': '右に歪んだ',
  'population.bimodal.label': '二峰性 (層あり)',
  'population.uniform.label': '一様',

  'venn.dice-even-or-prime.label': 'サイコロ: 偶数または素数',
  'venn.class-sports-2set.label': '競技 (2集合)',
  'venn.class-sports-3set.label': '競技 (3集合)',
  'venn.custom.label': 'カスタム',

  'tree.draw-without-replacement.label': '非復元抽出',
  'tree.custom.label': 'カスタム',
  'tree.coin.heads': '表',
  'tree.coin.tails': '裏',
  'tree.draw.start': '袋: 赤2, 青3',
  'tree.draw.red': '赤',
  'tree.draw.blue': '青',
  'tree.custom.start': '開始',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'ヒストグラム',
  'card.cumulative': '累積度数',
  'card.box': '箱ひげ図',
  'card.summary': '五数要約',
  'card.bar': '棒グラフ',
  'card.mode': '最頻値',
  'card.tag-frequency': 'タグ頻度',
  'card.mode-tag': '最頻タグ',
  'card.empty-no-order': '適用外',
  'card.empty-multi': '適用外',
  'card.numberline': '数直線',
  'card.scatter': '散布図',
  'card.description': '何が起きているか',
  'card.population': '母集団',
  'card.sampling-distribution': '標本平均',
  'card.venn': 'ベン',
  'card.tree': '樹形図',
  'card.probabilities': '確率',

  'param.dataset.label': 'データセット',
  'param.column.label': '列',
  'param.bins.label': '階級',
  'param.shape.label': '初期形状',
  'param.show-mean.label': '平均を表示',
  'param.show-median.label': '中央値を表示',
  'param.x-col.label': 'X列',
  'param.y-col.label': 'Y列',
  'param.show-regression.label': '回帰直線',
  'param.show-residuals.label': '残差',
  'param.show-confounder.label': '交絡を表示',
  'param.population.label': '母集団',
  'param.technique.label': '手法',
  'param.sample-size.label': '標本サイズ',
  'param.stratum.label': '層',
  'param.bias.label': 'バイアス',
  'param.mode.label': 'モード',
  'param.preset.label': 'プリセット',
  'param.universe.label': '全空間サイズ',
  'param.show-prob.label': '確率を表示',
  'param.treat-as-numeric.label': '数値として扱う',

  'stat.count': '個数',
  'stat.mean': '平均',
  'stat.median': '中央値',
  'stat.range': '範囲',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': '外れ値',
  'stat.r': 'ピアソン r',
  'stat.r2': 'r²',
  'stat.slope': '傾き',
  'stat.intercept': '切片',
  'stat.n': 'n',
  'stat.population-mean': '真の平均',
  'stat.latest-sample-mean': '標本平均',
  'stat.sample-mean-spread': '標本平均SD',
  'stat.sample-count': '抽出標本数',
  'outlier.upper': '上側外れ値',
  'outlier.lower': '下側外れ値',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': '再抽出',
  'btn.run-100': '100回抽出',
  'btn.stop': '停止',
  'btn.clear-history': '履歴を消去',

  'explainer.no-order': '順序なし → 累積も箱ひげも不可。',
  'explainer.multi-no-iqr': '複数値 → 四分位/IQR は未定義。',
  'message.no-data': 'データなし。',
  'message.needs-quartiles': '四分位には ≥4 点必要。',
  'message.x-zero-variance': 'X の分散がゼロ ── 直線を当てはめられない。',
  'message.n-too-small': 'n が小さすぎる。',
  'message.stratum-clamp': '層の行数が要求より少なかった ── 全行を使用。',
  'message.siblings-sum-to-one': '兄弟ノードの和は 1。',
};
